const EVENT = 'event';
const ON_LOAD = 'onLoad';
const ON_CLICK = 'onClick';
const IN_VIEW = 'inView';
const ON_SUCCESS = 'onSuccess';
const PAGE_VIEW = 'pageView';
const ECOMMERCE = 'ecommerce';
const GTM_PROPS = [{
  key: 'eventAction'
}, {
  key: 'eventLabel'
}, {
  key: 'eventCategory'
}, {
  key: 'eventName',
  label: 'event'
}];
const GTM_EVENT_NAMES = {
  productImpresion: 'impressions',
  productDetailImpression: 'detail',
  productClick: 'click',
  promotionClick: 'promotionClick'
};
const GTM_EVENT_FACTORY = 'GtmEventFactory';
const PLUGIN_NAME = 'gtm-fe';
const PRODUCTS = 'products';
export { PLUGIN_NAME, EVENT, ECOMMERCE, GTM_PROPS, GTM_EVENT_NAMES, GTM_EVENT_FACTORY, ON_CLICK, IN_VIEW, ON_SUCCESS, ON_LOAD, PRODUCTS, PAGE_VIEW };
//# sourceMappingURL=constants.js.map